import {ReactNode} from 'react'
import {COLORS_CODE} from '@utilities/constants'

export const ColorfulLogoIcon = ({...props}) => {
	return (
		<svg {...props} width="33" height="32" fill="none" viewBox="0 0 33 32">
			<g fillRule="evenodd" clipRule="evenodd">
				<path fill="#C83C2B" d="M11 11.13H.334v10.435H11V11.13zm10.667 10.435H11V32h10.667V21.565z"></path>
				<path fill="#123F9F" d="M21.668 0H11.002v21.565h21.333V10.783H21.668V0z"></path>
			</g>
		</svg>
	)
}

export const LogoIcon = ({...props}) => {
	return (
		<svg width="142" height="24" fill="none" viewBox="0 0 142 24" {...props}>
			<path
				fill="#fff"
				fillOpacity="0.5"
				fillRule="evenodd"
				d="M8 8.348H0v7.826h8V8.348zm8 7.826H8V24h8v-7.826z"
				clipRule="evenodd"
			></path>
			<path fill="#fff" fillRule="evenodd" d="M16 0H8v16.174h16V8.087h-8V0z" clipRule="evenodd"></path>
			<path
				fill="#fff"
				d="M32.208 8.624V7.04h8v1.584H37.12V18h-1.792V8.624h-3.12zM40.4 18v-8h1.728v.96c.906-.587 1.813-.965 2.72-1.136v1.744c-.918.181-1.702.416-2.352.704l-.352.144V18H40.4zm5.781 0v-8h1.744v8h-1.744zm0-9.36V6.8h1.744v1.84h-1.744zm9.78 3.824v3.648c.01.235.069.41.175.528.118.107.294.176.528.208l-.048 1.328c-.917 0-1.626-.197-2.128-.592-.853.395-1.712.592-2.576.592-1.589 0-2.384-.848-2.384-2.544 0-.81.214-1.397.64-1.76.438-.363 1.104-.581 2-.656l2.064-.176v-.576c0-.427-.096-.725-.288-.896-.181-.17-.453-.256-.816-.256-.682 0-1.536.043-2.56.128l-.512.032-.064-1.232c1.163-.277 2.23-.416 3.2-.416.982 0 1.686.213 2.112.64.438.416.656 1.083.656 2zm-3.585 1.984c-.736.064-1.104.464-1.104 1.2s.326 1.104.976 1.104a6.18 6.18 0 001.696-.256l.288-.096v-2.128l-1.856.176zm12.766 4.64c0 1.75-1.264 2.624-3.792 2.624-1.216 0-2.118-.165-2.704-.496-.587-.33-.88-.933-.88-1.808 0-.395.096-.736.288-1.024.192-.277.501-.581.928-.912-.352-.235-.528-.624-.528-1.168 0-.213.144-.56.432-1.04l.144-.24c-.768-.459-1.152-1.259-1.152-2.4 0-.96.288-1.664.864-2.112.576-.448 1.354-.672 2.336-.672.47 0 .933.053 1.392.16l.24.048 2.48-.064v1.408l-1.328-.08c.288.373.432.81.432 1.312 0 1.045-.267 1.77-.8 2.176-.523.395-1.344.592-2.464.592a3.3 3.3 0 01-.704-.064c-.15.363-.224.645-.224.848 0 .192.096.325.288.4.202.075.682.117 1.44.128 1.27.01 2.138.181 2.608.512.47.33.704.955.704 1.872zm-5.664.16c0 .373.15.64.448.8.298.16.81.24 1.536.24 1.29 0 1.936-.368 1.936-1.104 0-.416-.118-.683-.352-.8-.224-.107-.678-.165-1.36-.176l-1.568-.096c-.235.192-.4.368-.496.528a1.22 1.22 0 00-.144.608zm.128-6.624c0 .49.117.853.352 1.088.234.224.613.336 1.136.336.522 0 .896-.112 1.12-.336.234-.235.352-.597.352-1.088 0-.49-.118-.848-.352-1.072-.235-.235-.614-.352-1.136-.352-.982 0-1.472.475-1.472 1.424zm12.646 3.936l.448-.048.032 1.296c-1.216.245-2.293.368-3.232.368-1.184 0-2.037-.325-2.56-.976-.512-.65-.768-1.69-.768-3.12 0-2.837 1.157-4.256 3.472-4.256 2.24 0 3.36 1.221 3.36 3.664l-.112 1.248h-4.96c.01.661.155 1.147.432 1.456.277.31.795.464 1.552.464s1.536-.032 2.336-.096zm-.96-3.168c0-.79-.128-1.339-.384-1.648-.245-.32-.667-.48-1.264-.48s-1.035.165-1.312.496c-.267.33-.405.875-.416 1.632h3.376zM77.461 18l2.704-10.96H83.7L86.42 18h-1.792l-.592-2.352h-4.208L79.237 18H77.46zm4.08-9.472l-1.36 5.552h3.504L82.34 8.528h-.8zm11.786 3.12c-1.259-.17-2.17-.256-2.736-.256-.566 0-.96.07-1.184.208-.214.128-.32.336-.32.624s.117.49.352.608c.245.117.81.256 1.696.416.896.15 1.53.39 1.904.72.373.33.56.917.56 1.76s-.272 1.461-.816 1.856c-.534.395-1.318.592-2.352.592-.65 0-1.472-.09-2.464-.272l-.496-.08.064-1.456c1.28.17 2.202.256 2.768.256.565 0 .965-.07 1.2-.208.245-.139.368-.368.368-.688 0-.32-.118-.539-.352-.656-.224-.128-.774-.261-1.648-.4-.864-.15-1.499-.379-1.904-.688-.406-.31-.608-.875-.608-1.696s.277-1.435.832-1.84c.565-.405 1.285-.608 2.16-.608.682 0 1.52.085 2.512.256l.496.096-.032 1.456zm7.5 0c-1.259-.17-2.17-.256-2.736-.256-.566 0-.96.07-1.184.208-.214.128-.32.336-.32.624s.117.49.352.608c.245.117.81.256 1.696.416.896.15 1.53.39 1.904.72.373.33.56.917.56 1.76s-.272 1.461-.816 1.856c-.534.395-1.318.592-2.352.592-.65 0-1.472-.09-2.464-.272l-.496-.08.064-1.456c1.28.17 2.202.256 2.768.256.565 0 .965-.07 1.2-.208.245-.139.368-.368.368-.688 0-.32-.118-.539-.352-.656-.224-.128-.774-.261-1.648-.4-.864-.15-1.499-.379-1.904-.688-.406-.31-.608-.875-.608-1.696s.277-1.435.832-1.84c.565-.405 1.285-.608 2.16-.608.682 0 1.52.085 2.512.256l.496.096-.032 1.456zM102.775 18v-8h1.744v8h-1.744zm0-9.36V6.8h1.744v1.84h-1.744zm9.411 3.008c-1.259-.17-2.171-.256-2.736-.256-.565 0-.96.07-1.184.208-.213.128-.32.336-.32.624s.117.49.352.608c.245.117.811.256 1.696.416.896.15 1.531.39 1.904.72.373.33.56.917.56 1.76s-.272 1.461-.816 1.856c-.533.395-1.317.592-2.352.592-.651 0-1.472-.09-2.464-.272l-.496-.08.064-1.456c1.28.17 2.203.256 2.768.256s.965-.07 1.2-.208c.245-.139.368-.368.368-.688 0-.32-.117-.539-.352-.656-.224-.128-.773-.261-1.648-.4-.864-.15-1.499-.379-1.904-.688-.405-.31-.608-.875-.608-1.696s.277-1.435.832-1.84c.565-.405 1.285-.608 2.16-.608.683 0 1.52.085 2.512.256l.496.096-.032 1.456zm6.252-.16h-2.208v3.52c0 .65.048 1.083.144 1.296.096.213.341.32.736.32l1.312-.048.08 1.392c-.715.139-1.259.208-1.632.208-.907 0-1.531-.208-1.872-.624-.331-.416-.496-1.2-.496-2.352v-3.712h-1.024V10h1.024V7.68h1.728V10h2.208v1.488zm7.351.976v3.648c.01.235.069.41.176.528.117.107.293.176.528.208l-.048 1.328c-.918 0-1.627-.197-2.128-.592-.854.395-1.712.592-2.576.592-1.59 0-2.384-.848-2.384-2.544 0-.81.213-1.397.64-1.76.437-.363 1.104-.581 2-.656l2.064-.176v-.576c0-.427-.096-.725-.288-.896-.182-.17-.454-.256-.816-.256-.683 0-1.536.043-2.56.128l-.512.032-.064-1.232c1.162-.277 2.229-.416 3.2-.416.981 0 1.685.213 2.112.64.437.416.656 1.083.656 2zm-3.584 1.984c-.736.064-1.104.464-1.104 1.2s.325 1.104.976 1.104c.533 0 1.098-.085 1.696-.256l.288-.096v-2.128l-1.856.176zM129.722 18h-1.744v-8h1.728v.496c.779-.448 1.515-.672 2.208-.672 1.067 0 1.792.304 2.176.912.395.597.592 1.59.592 2.976V18h-1.728v-4.24c0-.864-.096-1.477-.288-1.84-.181-.363-.56-.544-1.136-.544-.544 0-1.067.107-1.568.32l-.24.096V18zm11.294-6.512h-2.208v3.52c0 .65.048 1.083.144 1.296.096.213.342.32.736.32l1.312-.048.08 1.392c-.714.139-1.258.208-1.632.208-.906 0-1.53-.208-1.872-.624-.33-.416-.496-1.2-.496-2.352v-3.712h-1.024V10h1.024V7.68h1.728V10h2.208v1.488z"
			></path>
		</svg>
	)
}

export const QRIcon = ({...props}) => {
	return (
		<svg {...props} width="28" height="28" fill="none" viewBox="0 0 28 28">
			<path
				stroke="#06C"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M7.583 7.583h.012m12.822 0h.011M7.583 20.417h.012m7.572-5.25h.011m5.239 5.25h.011m-.595 4.083H24.5v-4.667m-8.167-.583v5.25m8.167-8.167h-5.25m-1.05-4.666h4.433c.654 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.577.127-1.23V5.367c0-.654 0-.98-.127-1.23a1.166 1.166 0 00-.51-.51c-.25-.127-.576-.127-1.23-.127H18.2c-.653 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23V9.8c0 .653 0 .98.128 1.23.111.22.29.398.51.51.249.127.576.127 1.229.127zm-12.833 0H9.8c.653 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.577.127-1.23V5.367c0-.654 0-.98-.127-1.23a1.166 1.166 0 00-.51-.51C10.78 3.5 10.453 3.5 9.8 3.5H5.367c-.654 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23V9.8c0 .653 0 .98.127 1.23.112.22.29.398.51.51.25.127.576.127 1.23.127zm0 12.833H9.8c.653 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V18.2c0-.653 0-.98-.127-1.23a1.166 1.166 0 00-.51-.51c-.25-.127-.577-.127-1.23-.127H5.367c-.654 0-.98 0-1.23.128-.22.111-.398.29-.51.51-.127.249-.127.576-.127 1.229v4.433c0 .654 0 .98.127 1.23.112.22.29.398.51.51.25.127.576.127 1.23.127z"
			></path>
		</svg>
	)
}

export const AvatarIcon = ({...props}) => {
	return (
		<svg {...props} width="20" height="20" fill="none" viewBox="0 0 20 20">
			<path
				fill="#06C"
				fillRule="evenodd"
				d="M10 10.834A3.333 3.333 0 0013.335 7.5V5a3.333 3.333 0 00-6.667 0v2.5a3.333 3.333 0 003.334 3.334zM7.5 5a2.5 2.5 0 015 0v2.5a2.5 2.5 0 01-5 0V5zm8.334 13.334h.833a6.667 6.667 0 00-13.333 0h.833a5.833 5.833 0 1111.667 0z"
				clipRule="evenodd"
			></path>
		</svg>
	)
}

export const CheckIcon = ({size = 24, ...props}) => {
	return (
		<svg {...props} width={size} height={size} fill="none" viewBox="0 0 24 24">
			<path
				fill="#008055"
				fillRule="evenodd"
				d="M12.417 22C6.664 22 2 17.523 2 12S6.664 2 12.417 2c2.762 0 5.412 1.054 7.365 2.929 1.954 1.875 3.051 4.419 3.051 7.071 0 5.523-4.663 10-10.416 10zm5.312-14.1l.73.7-8.126 7.6-4.896-4.6.73-.7 4.166 3.9 7.396-6.9zM12.417 3c5.177 0 9.375 4.03 9.375 9s-4.198 9-9.375 9c-5.178 0-9.375-4.03-9.375-9s4.197-9 9.375-9z"
				clipRule="evenodd"
			/>
		</svg>
	)
}

export const DownloadIcon = ({...props}) => {
	return (
		<svg {...props} width="16" height="14" viewBox="0 0 16 14" style={{marginTop: '4px'}}>
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<g fill="#06C" fillRule="nonzero">
					<path d="M.5 8.9a.5.5 0 01.5.5v2.5a1 1 0 001 1h12a1 1 0 001-1V9.4a.5.5 0 111 0v2.5a2 2 0 01-2 2H2a2 2 0 01-2-2V9.4a.5.5 0 01.5-.5"></path>
					<path d="M7.646 10.854a.5.5 0 00.708 0l3-3a.5.5 0 00-.708-.708L8.5 9.293V.5a.5.5 0 00-1 0v8.793L5.354 7.146a.5.5 0 00-.708.708l3 3z"></path>
				</g>
			</g>
		</svg>
	)
}

export const CheckedIcon = ({size = 30, ...props}) => {
	return (
		<svg viewBox="0 0 52 52" width={size} height={size} {...props}>
			<circle cx="26" cy="26" r="25" stroke="#06c" strokeWidth="2" fill="#06c" />
			<path d="M14.1 27.2l7.1 7.2 16.7-16.8" stroke="#fff" strokeWidth="2" fill="none" />
		</svg>
	)
}

export const InfoIcon = ({size = 20, fill = '#06C', ...props}) => {
	return (
		<svg {...props} width={size} height={size} fill="none" viewBox="0 0 20 20">
			<path
				fill={fill}
				fillRule="evenodd"
				d="M1.667 10a8.333 8.333 0 1116.667 0 8.333 8.333 0 01-16.667 0zm.833 0a7.5 7.5 0 1015 0 7.5 7.5 0 00-15 0zm6.917-5h1.25v1.667h-1.25V5zm1.25 2.5h-1.25V15h1.25V7.5z"
				clipRule="evenodd"
			></path>
		</svg>
	)
}

export const ArrowIcon = ({...props}) => {
	return (
		<svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
			<g>
				<path fill="#06C" d="M21 11.5H5.5l5.3-5.4-.7-.7L3.6 12l6.5 6.6.7-.7-5.3-5.4H21v-1z"></path>
			</g>
		</svg>
	)
}

export const UserIcon = ({...props}) => {
	return (
		<svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
			<g>
				<path
					stroke="#06C"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
					d="M3 20c2.336-2.477 5.507-4 9-4 3.493 0 6.664 1.523 9 4M16.5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
				></path>
			</g>
		</svg>
	)
}

export const MedicalCrossIcon = ({...props}) => {
	return (
		<svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
			<g>
				<path
					stroke="#06C"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
					d="M15 4.6c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C9 3.76 9 4.04 9 4.6v2.8c0 .56 0 .84-.109 1.054a1 1 0 01-.437.437C8.24 9 7.96 9 7.4 9H4.6c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C3 9.76 3 10.04 3 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C3.76 15 4.04 15 4.6 15h2.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C9 15.76 9 16.04 9 16.6v2.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C9.76 21 10.04 21 10.6 21h2.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C15 20.24 15 19.96 15 19.4v-2.8c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C15.76 15 16.04 15 16.6 15h2.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C21 14.24 21 13.96 21 13.4v-2.8c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C20.24 9 19.96 9 19.4 9h-2.8c-.56 0-.84 0-1.054-.109a1 1 0 01-.437-.437C15 8.24 15 7.96 15 7.4V4.6z"
				></path>
			</g>
		</svg>
	)
}

export const HeartIcon = ({...props}) => {
	return (
		<svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
			<g>
				<path
					fillRule="evenodd"
					stroke="#06C"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
					d="M11.993 5.136c-2-2.338-5.333-2.966-7.838-.826s-2.858 5.719-.89 8.25c1.635 2.105 6.585 6.544 8.207 7.98.182.162.272.242.378.274a.504.504 0 00.286 0c.106-.032.197-.112.378-.273 1.623-1.437 6.573-5.876 8.208-7.98 1.967-2.532 1.658-6.133-.89-8.251-2.549-2.118-5.84-1.512-7.839.826z"
					clipRule="evenodd"
				></path>
			</g>
		</svg>
	)
}

export const CameraIcon = ({...props}) => {
	return (
		<svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
			<g>
				<g stroke="#06C" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
					<path d="M2 8.377c0-.35 0-.525.015-.673a3 3 0 012.69-2.69C4.851 5 5.035 5 5.404 5c.143 0 .214 0 .274-.004a2 2 0 001.735-1.25c.023-.056.044-.12.086-.246.042-.127.063-.19.086-.246a2 2 0 011.735-1.25C9.38 2 9.448 2 9.58 2h4.838c.133 0 .2 0 .26.004a2 2 0 011.735 1.25c.023.056.044.12.086.246.042.127.063.19.086.246a2 2 0 001.735 1.25c.06.004.131.004.273.004.37 0 .554 0 .702.015a3 3 0 012.69 2.69c.014.147.014.322.014.672V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C2 18.72 2 17.88 2 16.2V8.377z"></path>
					<path d="M12 16.5a4 4 0 100-8 4 4 0 000 8z"></path>
				</g>
			</g>
		</svg>
	)
}

export const TextInputIcon = ({...props}) => {
	return (
		<svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
			<g>
				<path
					stroke="#06C"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
					d="M13 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C2 8.52 2 9.08 2 10.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C3.52 17 4.08 17 5.2 17H13m4-10h1.8c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C22 8.52 22 9.08 22 10.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874C20.48 17 19.92 17 18.8 17H17m0 4V3m2.5 0h-5m5 18h-5"
				></path>
			</g>
		</svg>
	)
}

export const UsersIcon = ({...props}) => {
	return (
		<svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
			<g>
				<path
					stroke="#06C"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
					d="M16 4.468a4.5 4.5 0 010 8.064m2 5.234c1.512.684 2.872 1.799 4 3.234M2 21c1.946-2.477 4.59-4 7.5-4s5.553 1.523 7.5 4M14 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
				></path>
			</g>
		</svg>
	)
}

export const MeIcon = ({...props}) => {
	return (
		<svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
			<g>
				<path
					stroke="#06C"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
					d="M3 20c2.336-2.477 5.507-4 9-4 3.493 0 6.664 1.523 9 4M16.5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
				></path>
			</g>
		</svg>
	)
}

export const CheckCircleIcon = ({...props}) => {
	return (
		<svg {...props} width="49" height="49" fill="none" viewBox="0 0 49 49">
			<path
				fill="#008055"
				fillRule="evenodd"
				d="M25.333 44.5C13.827 44.5 4.5 35.546 4.5 24.5s9.327-20 20.833-20c5.526 0 10.825 2.107 14.732 5.858 3.907 3.75 6.102 8.838 6.102 14.142 0 11.046-9.328 20-20.834 20zm10.625-28.2l1.459 1.4-16.25 15.2-9.792-9.2 1.458-1.4 8.334 7.8 14.791-13.8zM25.333 6.5c10.356 0 18.75 8.059 18.75 18s-8.394 18-18.75 18c-10.355 0-18.75-8.059-18.75-18s8.395-18 18.75-18z"
				clipRule="evenodd"
			></path>
		</svg>
	)
}

export const UncheckedCircleIcon = ({...props}) => {
	return (
		<svg {...props} width="28" height="28" fill="none" viewBox="0 0 28 28">
			<path
				fill="#CC334D"
				fillRule="evenodd"
				d="M14 25.667C7.556 25.667 2.333 20.443 2.333 14S7.556 2.334 14 2.334A11.667 11.667 0 0125.666 14c0 6.444-5.223 11.667-11.666 11.667zm5.016-15.984L14.7 14l4.316 4.2-.816.817-4.317-4.2-4.2 4.2-.817-.817 4.2-4.2-4.2-4.316.817-.817 4.2 4.316L18.2 8.867l.816.816zM14 3.5c5.799 0 10.5 4.701 10.5 10.5 0 5.8-4.701 10.5-10.5 10.5-5.8 0-10.5-4.7-10.5-10.5C3.5 8.201 8.2 3.5 14 3.5z"
				clipRule="evenodd"
			></path>
		</svg>
	)
}

export const CloseIcon = ({...props}) => {
	return (
		<svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
			<path
				fill="#5C6F82"
				d="M12.7 12l6.7 6.6-.8.8-6.6-6.7-6.6 6.7-.8-.8 6.7-6.6-6.7-6.6.8-.8 6.6 6.7 6.6-6.7.8.8-6.7 6.6z"
			></path>
		</svg>
	)
}

export const RedCodeIcon = ({...props}) => {
	return (
		<svg {...props} width="36" height="36" fill="none" viewBox="0 0 36 36">
			<rect width="36" height="36" fill={COLORS_CODE.red} rx="18"></rect>
			<path fill="#fff" d="M20.1 11.8V25h-2.22V14.32l-3.1 2-1.02-1.66 4.3-2.86h2.04z"></path>
		</svg>
	)
}

export const OrangeCodeIcon = ({...props}) => {
	return (
		<svg {...props} width="36" height="36" fill="none" viewBox="0 0 36 36">
			<rect width="36" height="36" fill={COLORS_CODE.orange} rx="18"></rect>
			<path
				fill="#fff"
				d="M21.84 25h-8.5v-1.9l3.26-3.36c.987-1.013 1.68-1.807 2.08-2.38.4-.573.6-1.2.6-1.88 0-.693-.193-1.187-.58-1.48-.387-.293-1.02-.44-1.9-.44-.827 0-1.74.093-2.74.28l-.5.08-.14-1.76a13.957 13.957 0 014.02-.58c2.76 0 4.14 1.227 4.14 3.68 0 .96-.213 1.793-.64 2.5-.413.707-1.16 1.56-2.24 2.56l-2.82 2.74h5.96V25z"
			></path>
		</svg>
	)
}

export const BluCodeIcon = ({...props}) => {
	return (
		<svg {...props} width="36" height="36" fill="none" viewBox="0 0 36 36">
			<rect width="36" height="36" fill={COLORS_CODE.blue} rx="18"></rect>
			<path
				fill="#fff"
				d="M13.32 12.22c1.24-.427 2.6-.64 4.08-.64s2.553.287 3.22.86c.68.56 1.02 1.453 1.02 2.68 0 .533-.107 1.013-.32 1.44-.2.427-.407.74-.62.94-.213.187-.48.387-.8.6.707.333 1.213.7 1.52 1.1.32.387.48 1.02.48 1.9 0 1.4-.353 2.44-1.06 3.12-.693.667-1.807 1-3.34 1-.6 0-1.26-.053-1.98-.16a15.748 15.748 0 01-1.72-.3l-.62-.16.14-1.72c1.467.267 2.76.4 3.88.4 1.6-.013 2.4-.72 2.4-2.12 0-.64-.207-1.127-.62-1.46-.413-.333-.96-.507-1.64-.52h-2.66v-1.86h2.66c.493 0 .947-.2 1.36-.6.427-.413.64-.907.64-1.48 0-.587-.187-1.02-.56-1.3-.36-.28-.86-.42-1.5-.42-1.053 0-2.14.093-3.26.28l-.52.1-.18-1.68z"
			></path>
		</svg>
	)
}

export const GreenCodeIcon = ({...props}) => {
	return (
		<svg {...props} width="36" height="36" fill="none" viewBox="0 0 36 36">
			<rect width="36" height="36" fill={COLORS_CODE.green} rx="18"></rect>
			<path
				fill="#fff"
				d="M18.74 25v-2.36H12.8v-1.7l3.48-9.14h2.46l-3.68 8.9h3.68v-3.88h2.24v3.88h1.44v1.94h-1.44V25h-2.24z"
			></path>
		</svg>
	)
}

export const WhiteCodeIcon = ({...props}) => {
	return (
		<svg {...props} width="38" height="38" fill="none" viewBox="0 0 38 38">
			<rect width="37" height="37" x="0.5" y="0.5" fill={COLORS_CODE.white} rx="18.5"></rect>
			<rect width="37" height="37" x="0.5" y="0.5" stroke="#C5C7C9" rx="18.5"></rect>
			<path
				fill="#1A1A1A"
				d="M22.68 12.8v1.96h-6.12l-.34 3.48c.907-.413 1.8-.62 2.68-.62 2.827 0 4.24 1.32 4.24 3.96 0 1.493-.393 2.64-1.18 3.44-.773.8-1.873 1.2-3.3 1.2-.6 0-1.28-.06-2.04-.18a21.12 21.12 0 01-1.82-.32l-.68-.18.24-1.68c1.573.267 2.92.4 4.04.4.773 0 1.373-.213 1.8-.64.427-.427.64-1.033.64-1.82 0-.787-.187-1.353-.56-1.7-.373-.347-.86-.52-1.46-.52-1.08 0-1.96.133-2.64.4l-.36.14-1.4-.3.36-7.02h7.9z"
			></path>
		</svg>
	)
}
interface ChevronDownIconProps {
	size: number
}

export const ChevronDownIcon = ({size, ...props}: ChevronDownIconProps) => {
	return (
		<svg viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.670 8.061 C 5.448 8.142,5.250 8.309,5.128 8.516 C 5.036 8.672,5.020 8.745,5.021 9.000 C 5.021 9.212,5.043 9.341,5.095 9.440 C 5.195 9.632,11.294 15.738,11.520 15.873 C 11.673 15.964,11.745 15.980,12.000 15.979 C 12.212 15.979,12.341 15.957,12.440 15.905 C 12.632 15.805,18.738 9.706,18.873 9.480 C 18.964 9.328,18.980 9.254,18.980 9.000 C 18.980 8.746,18.963 8.672,18.872 8.516 C 18.618 8.084,18.138 7.906,17.657 8.065 C 17.478 8.125,17.210 8.380,14.730 10.854 L 12.000 13.578 9.270 10.854 C 6.790 8.380,6.522 8.125,6.343 8.065 C 6.107 7.987,5.874 7.986,5.670 8.061 "
			/>
		</svg>
	)
}

interface XCloseIconProps {
	fill?: string
	size?: number
	onClick?: () => void
	className?: string
}

export const XCloseIcon = ({fill = '#06C', size = 24, className, ...props}: XCloseIconProps) => {
	return (
		<svg viewBox="0 0 24 24" width={size} height={size} fill={fill} {...props} className={className}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.670 5.061 C 5.448 5.142,5.250 5.309,5.128 5.516 C 5.036 5.672,5.020 5.745,5.021 6.000 C 5.021 6.212,5.043 6.341,5.095 6.440 C 5.135 6.517,6.386 7.800,7.874 9.290 L 10.579 12.000 7.874 14.710 C 6.386 16.200,5.135 17.483,5.095 17.560 C 5.043 17.659,5.021 17.788,5.021 18.000 C 5.020 18.258,5.036 18.327,5.133 18.492 C 5.263 18.714,5.502 18.901,5.736 18.965 C 5.938 19.019,6.266 18.989,6.445 18.899 C 6.519 18.862,7.800 17.614,9.290 16.126 L 12.000 13.421 14.710 16.126 C 16.200 17.614,17.483 18.865,17.560 18.905 C 17.659 18.957,17.788 18.979,18.000 18.979 C 18.258 18.980,18.327 18.964,18.492 18.867 C 18.714 18.737,18.901 18.498,18.965 18.264 C 19.019 18.062,18.989 17.734,18.899 17.555 C 18.862 17.481,17.614 16.200,16.126 14.710 L 13.421 12.000 16.126 9.290 C 17.614 7.800,18.865 6.517,18.905 6.440 C 18.957 6.341,18.979 6.212,18.979 6.000 C 18.980 5.745,18.964 5.672,18.872 5.516 C 18.618 5.084,18.138 4.906,17.657 5.065 C 17.478 5.125,17.210 5.380,14.730 7.854 L 12.000 10.578 9.270 7.854 C 6.790 5.380,6.522 5.125,6.343 5.065 C 6.107 4.987,5.874 4.986,5.670 5.061 "
			/>
		</svg>
	)
}

export const BodyModel = ({
	width,
	height,
	renderZones,
	renderOutlines,
	...props
}: {
	width: number | undefined
	height: number | undefined
	renderZones: (ReactNode | undefined)[] | undefined
	renderOutlines: (ReactNode | undefined) | undefined
}) => {
	return (
		<svg {...props} fill="none" width={'100%'} height={'100%'} viewBox={`0 0 ${width} ${height}`}>
			{/* Body */}
			{renderZones}

			{/* Outlines */}
			{renderOutlines}
		</svg>
	)
}
